export const REACT_APP_MAPBOX_TOKEN="pk.eyJ1IjoidGRob3BraW5zIiwiYSI6ImNrZXlrY285OTBnM3MzNHAzcXZzZ20yN2oifQ.Dc_ERVxx2U3vCm-HUNIC3w"
export const REACT_APP_OPENCAGE_API_KEY="b880199178f34733bd3da0d7ef4b946f" 
export const FB_APP_ID="812375526095648"

